<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBell_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M4.522 1.523a4.916 4.916 0 0 1 8.396 3.48c0 2.32.496 3.755.949 4.587.228.418.449.69.601.852a2.015 2.015 0 0 0 .205.19.754.754 0 0 1-.427 1.375H1.754a.754.754 0 0 1-.428-1.375h.001a2.043 2.043 0 0 0 .205-.19c.152-.161.373-.434.601-.852.453-.832.949-2.268.949-4.587 0-1.305.518-2.557 1.44-3.48Zm2.453 11.842a.754.754 0 0 0-1.392.581c.232.556.577 1.046 1.022 1.403.45.36.987.57 1.559.57s1.11-.21 1.559-.57c.445-.357.79-.848 1.022-1.403a.754.754 0 0 0-1.392-.58c-.15.361-.356.632-.572.805a.985.985 0 0 1-.617.239.985.985 0 0 1-.617-.239c-.216-.173-.421-.444-.572-.806Z"
        clip-rule="evenodd"
    />
</svg>
